import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  type ErrorComponentProps,
  Link,
  Outlet,
} from "@tanstack/react-router";
import { AuthFrame } from "../components/shell/AuthFrame";
import { IconSprite } from "../components/ui/primitives";
import { t } from "../i18n";
import { useUi } from "../state/ui";

export type RouterContext = { queryClient: QueryClient };

function Toasts() {
  const toasts = useUi((s) => s.toasts);
  const act = useUi((s) => s.actOnToast);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast-note${t.error ? " err" : ""}${t.action ? " has-action" : ""}`}
        >
          <span className="toast-text">{t.text}</span>
          {t.action && (
            <button type="button" className="toast-action" onClick={() => act(t.id)}>
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

function NotFound() {
  return (
    <AuthFrame>
      <div className="auth-card">
        <h2>{t("shell.pageNotFound")}</h2>
        <p>{t("shell.pageNotFoundBody")}</p>
        <Link to="/" className="btn btn-primary btn-block">
          {t("shell.goHome")}
        </Link>
      </div>
    </AuthFrame>
  );
}

function ErrorPage({ error }: ErrorComponentProps) {
  console.error(error);
  return (
    <AuthFrame>
      <div className="auth-card">
        <h2>{t("shell.somethingWentWrong")}</h2>
        <p>{t("shell.errorBody")}</p>
        <button
          type="button"
          className="btn btn-primary btn-block"
          onClick={() => window.location.reload()}
        >
          {t("shell.reload")}
        </button>
      </div>
    </AuthFrame>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <IconSprite />
      <Outlet />
      <Toasts />
    </>
  ),
  notFoundComponent: NotFound,
  errorComponent: ErrorPage,
});
